<template>
  <div>
    <Datepicker
        v-if="!loading && success === ''"
        mode="dateTime"
        class="w-100 h-100"
        style="position:relative;"
        v-model="day"
    >
    </Datepicker>
    <div v-if="loading" class="mb-4 text-center">
      <img src="@/assets/dashboard/img/spinner.gif" style="width: 100px;" alt="...">
    </div>
    <div v-if="!loading && success !== ''" class="alert alert-success mb-4 text-center">
      {{ success }}
    </div>
    <div class="mt-5">
      <button type="button" class="btn btn-primary" :disabled="loading || success !== ''" @click.prevent="save()">Book
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import authHeader from "@/services/auth-header";

export default {
  data() {
    return {
      success: '',
      loading: false,
      day: null,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    async save() {
      this.loading = true;
      let data = {
        'day': this.day,
      }
      let email = this.$store.getters['auth/email'];
      await axios.post(`/api/v2/book-date/${email}`, data, {headers: authHeader()})
          .then(() => {
            this.success = 'Date and Time booked, you will receive an email that contains all the details!';
            this.loading = false;
          })
      this.loading = false;
    }
  },
}
</script>
